export const EVENTS: any = {
  VIEW_PAGE: 'Page View',
  LOGOUT: 'Logout',
  LOGIN: 'Login',
  UPGRADE_SELECTED: 'UPGRADE_SELECTED',

  VIEW_GET_STARTED: 'View Get Started',
  VIEW_DASHBOARD: 'View Dashboard',
  VIEW_AWARDS: 'View Awards',
  VIEW_REVIEWS: 'View Reviews',
  VIEW_WIDGETS: 'View Widgets',
  VIEW_COMPANIES: 'View Companies',
  VIEW_DEVELOPMENTS: 'View Developments',
  VIEW_RESIDENT_OUTREACH: 'View Resident Outreach',
  VIEW_ANALYTICS: 'View Analytics',
  VIEW_MEDIA: 'View Media',
  VIEW_GUIDES: 'View Guides',
  VIEW_USERS: 'View Users',
  VIEW_RESOURCES: 'View Resources',
  VIEW_PROFILE: 'View Profile',

  DASHBOARD_DEVELOPMENT_FILTER: 'Dashboard Development Filter',
  DASHBOARD_REVIEWER_TYPE_FILTER: 'Dashboard Reviewer Type Filter',
  DASHBOARD_OWNER_TYPE_FILTER: 'Dashboard Owner Type Filter',
  DASHBOARD_AGE_FILTER: 'Dashboard Reviewer Age Filter',
  DASHBOARD_DATE_FILTER: 'Dashboard Date Filter',
  DASHBOARD_DATE_RANGE_FILTER: 'Dashboard Preset Date Range Filter',
  DASHBOARD_RESET_FILTERS: 'Dashboard Reset Filters',
  DASHBOARD_CHART_FILTER_CHANGE: 'Dashboard Chart Filter Change',
  DASHBOARD_DOWNLOAD_CHART: 'Download Chart',

  REVIEWS_SEARCH_FILTER: 'Reviews Search',
  REVIEWS_DEVELOPMENT_FILTER: 'Reviews Development Filter',
  REVIEWS_REVIEWER_TYPE_FILTER: 'Reviews Reviewer Type Filter',
  REVIEWS_RESPONSE_TYPE_FILTER: 'Reviews Response Filter',
  REVIEWS_VERIFIED_FILTER: 'Reviews Verification Filter',
  REVIEWS_DATE_FILTER: 'Reviews Date Filter',
  REVIEWS_RESET_FILTERS: 'Reviews Reset Filters',
  REVIEWS_SELECT_VIEW: 'Reviews View Change',
  REVIEWS_SELECT_FULL_REVIEW: 'Reviews Read More',
  REVIEWS_SORT: 'Reviews Sort',
  REVIEWS_RESPONSE: 'Reviews Response',

  DEVELOPMENTS_LOCATION_FILTER: 'DEVELOPMENTS_LOCATION_FILTER',
  DEVELOPMENTS_RATING_FILTER: 'DEVELOPMENTS_RATING_FILTER',
  DEVELOPMENTS_RESET_FILTERS: 'DEVELOPMENTS_RESET_FILTERS',
  DEVELOPMENTS_SELECT_TABLE_VIEW: ' DEVELOPMENTS_SELECT_TABLE_VIEW',
  DEVELOPMENTS_SELECT_CARD_VIEW: ' DEVELOPMENTS_SELECT_CARD_VIEW',
  DEVELOPMENTS_VIEW_DEVELOPMENT: 'DEVELOPMENTS_VIEW_DEVELOPMENT',
  DEVELOPMENTS_SUBMIT_CHANGES: 'Developments Submit Changes',
  DEVELOPMENTS_CANCEL_CHANGES: 'Development cancel changes',

  MEDIA_ADD_NEW_MEDIA: 'MEDIA_ADD_NEW_MEDIA',
  RESOURCES_ADD_NEW_MEDIA: 'RESOURCES_ADD_NEW_MEDIA',

  GUIDES_DOWNLOAD: 'Resources_DOWNLOAD',
  GUIDES_SEARCH: 'Guides Search',
  GUIDES_FORMAT_FILTER: 'Guides Format Filter',
  GUIDES_TYPE_FILTER: 'Guides Type Filter',
  GUIDES_RESET_FILTERS: 'Guides Reset Filters',

  RESOURCES_DOWNLOAD: 'Resources_DOWNLOAD',
  RESOURCES_SEARCH: 'Resources Search',
  RESOURCES_FORMAT_FILTER: 'Resources Format Filter',
  RESOURCES_TYPE_FILTER: 'Resources Type Filter',
  RESOURCES_RESET_FILTERS: 'Resources Reset Filters',

  WIDGETS_CREATE_WIDGET: 'WIDGETS_CREATE_WIDGET',
  WIDGETS_GENERATE_WIDGET: 'WIDGETS_GENERATE_WIDGET',
  WIDGETS_COPY_WIDGET: 'Widget Code Copy',
  WIDGETS_VIEW_WIDGET: 'Widget View',

  PROFILE_SAVE: 'Profile Edit',

  COMPANY_SUBMIT_CHANGES: 'Company Edit Submitted',

  COMPANY_USERS_CREATE: 'Users Create',
  COMPANY_USERS_PERMISSIONS_SET: 'Users Set Permissions',
  COMPANY_USERS_EDIT: 'Users Edit',

  WEB_SESSION: 'Web session',

  COMPANY_VIEW_COMPANY: 'COMPANY_VIEW_COMPANY',
  COMPANY_ADD_NEW_MEDIA: 'COMPANY_ADD_NEW_MEDIA',
  COMPANY_CANCEL_CHANGES: 'COMPANY_CANCEL_CHANGES',
  AWARDS_YEAR_FILTER: 'AWARDS_YEAR_FILTER',
}
